import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import standByActions from 'actions/standByActions';
import preLoaderActions from 'actions/preLoaderActions';
import stepsActions from 'actions/stepsActions';
import { ProfessionalDataView as ProfessionalDataViewComponent } from './ProfessionalDataView';

export const ProfessionalDataView = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        immStandByState: state.standBy,
        immErrorState: state.error,
        products: state.products,
        immJointHoldersStatus: state.jointHoldersStatus,
    }),
    dispatch => ({
        standByActions: bindActionCreators(standByActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
    })
)(ProfessionalDataViewComponent);
